import { createRouter, createWebHistory } from "vue-router";
import Tables from "../views/Tables.vue";
import store from '@/store/store.js'
import i18n from "@/i18n";
import { ElNotification } from 'element-plus'
import NotFound from "@/views/NotFound.vue";
import { getDefaultDashboardId } from "@/helpers/defaultDashboard";
import { getSystemDashboardIdForResource } from "@/helpers/systemDashboards";
import { getFirstAccessibleSection } from "@/helpers/firstAccessibleSection";

let siteName = ' - Graspil App'
const routes = [
  {
    path: "/test",
    name: "test",
    component: () => import('@/views/test.vue')
  },
  {
    path: "/",
    name: "Home",
    // redirect: "/dashboard-default",
    // component: Dashboard,
    component: () => import('@/views/Dashboard/Dashboard.vue'),
    meta: { title: i18n.global.t('Meta.Title.Home') + siteName }
  },
  {
    // Old fixed dashboard, kept reachable directly (not via "/") since "/" always
    // redirects to the default/system dashboard now.
    path: "/dashboard-old",
    name: "DashboardOld",
    component: () => import('@/views/Dashboard/Dashboard.vue'),
    meta: { title: i18n.global.t('Meta.Title.Home') + siteName }
  },
  {
    path: "/users/:user_id?",
    name: "Users",
    component: () => import('@/views/users/UsersList.vue'),
    meta: { title: 'Users - ' + siteName }
  },
  {
    // Ручная модерация заявок на вступление. Есть только у каналов и групп — у бота в личке
    // заявок на вступление не существует; пункт меню скрыт для type=1 (SidenavList.vue).
    path: "/join-requests",
    name: "JoinRequests",
    component: () => import('@/views/joinRequests/JoinRequestsList.vue'),
    meta: { title: 'Join requests - ' + siteName }
  },
  {
    path: "/conversion",
    name: "Conversions",
    component: () => import('@/views/conversions/Conversions_list.vue'),
    meta: { title: 'Conversions - ' + siteName }
  },
  {
    path: "/targets",
    name: "Targets",
    component: () => import('@/views/conversions/Conversion_settings.vue')
  },
  {
    path: "/targets/:id",
    name: "EditTarget",
    component: () => import('@/views/conversions/EditTarget.vue')
  },
  {
    path: "/event-rules",
    name: "EventRules",
    component: () => import('@/views/eventRules/EventRules_list.vue'),
    meta: { title: 'Event Rules - ' + siteName }
  },
  {
    path: "/event-rules/:group_id",
    name: "EditEventRule",
    component: () => import('@/views/eventRules/EditEventRule.vue')
  },
  {
    path: "/utm-builder",
    name: "UtmBuilder",
    component: () => import('@/views/utmBuilder/UtmBuilderPage.vue')
  },
  {
    path: "/code4-site",
    name: "CodeForSite",
    component: () => import('@/views/CodeForSite.vue')
  },
  {
    path: "/resorces",
    name: "Resources",
    component: () => import('@/views/bots/BotsList.vue')
  },
  {
    path: "/bots",
    redirect: "/resorces"
  },
  {
    // Old Telegram-only connection form (EditBot.vue/BotForm.vue) — replaced by the
    // universal edit-mode wizard. Kept unreferenced rather than deleted for now; not
    // reachable through normal navigation any more.
    path: "/bots/:key",
    redirect: to => ({ path: `/resources/${to.params.key}/edit` })
  },
  {
    path: "/resorces/:key/permissions",
    name: "ResourcePermissions",
    component: () => import('@/views/bots/ResourcePermissions.vue'),
    meta: {} // requireTariff: 3
  },
  {
    path: "/bots/:key/permissions",
    redirect: to => ({ path: `/resorces/${to.params.key}/permissions` })
  },
  {
    path: "/bot_upload/:key",
    name: "Bot_upload",
    // component: Bot,
    component: () => import('@/views/bots/ConnectBotUpload.vue')
  },
  {
    path: "/resources/:key",
    name: "ResourceInfo",
    component: () => import('@/views/bots/BotPage/BotPage.vue')
  },
  {
    path: "/resources/:key/edit",
    name: "ResourceEdit",
    component: () => import('@/views/bots/ResourceConnectSettings.vue')
  },
  {
    path: "/bot/:key",
    redirect: to => ({ path: `/resources/${to.params.key}` })
  },
  {
    path: "/bot_errors",
    name: "BotErrors",
    component: () => import('@/views/botErrors/ErrorsList.vue')
  },
  {
    path: "/add-bot",
    redirect: "/resorces/connect"
  },
  {
    path: "/resorces/connect",
    name: "ConnectBot",
    component: () => import('@/views/bots/AddResource.vue')
  },
  {
    path: "/resorces/add-channel",
    redirect: "/resorces/connect"
  },
  {
    path: "/channels/add",
    redirect: "/resorces/connect"
  },
  {
    path: "/reports/:type_report(visitors|messages_from_user|new_users|left_users|return_users|rejection|session_count|avg_duration_session|avg_events_session|utm_summary|active_users|conversion_summary|app_session_source|app_session_device|app_session_version)", // :type_report(new-users|left-users|return-users|rejection)
    name: "Reports",
    // component: StandartReport,
    component: () => import('@/views/reports/StandartReport.vue')
    // children: [
    //   {
    //     path: "visitors",
    //     params: {
    //       type_report: "visitors",
    //     },
    //     name: "reports-visitors",
    //     component: StandartReport,
    //   }
    // ]
  },
  // {
  //   path: "/reports/visitors",
  //   name: "reports-visitors",
  //   component: StandartReport,
  // },
  // {
  //   path: "/reports/new-users",
  //   name: "reports-new-users",
  //   component: StandartReport,
  // },
  // {
  //   path: "/reports/left-users",
  //   name: "reports-left-users",
  //   component: StandartReport,
  // },
  // {
  //   path: "/reports/return-users",
  //   name: "reports-return-users",
  //   component: StandartReport,
  // },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/tariff",
    name: "Tariff",
    component: () => import('@/views/tariff/Tariff.vue')
  },
  {
    path: "/billing",
    name: "BillingV2",
    component: () => import('@/views/billing/BillingV2.vue')
  },
  // {
  //   path: "/virtual-reality",
  //   name: "Virtual Reality",
  //   component: VirtualReality,
  // },
  // {
  //   path: "/rtl-page",
  //   name: "RTL",
  //   component: RTL,
  // },
  {
    path: "/profile",
    name: "Profile",
    component: () => import('@/views/pofile/Profile.vue')
  },
  {
    path: "/api-keys",
    name: "ApiKeys",
    component: () => import('@/views/apiKeys/ApiKeys.vue')
  },
  {
    path: "/outpost",
    name: "Outpost",
    component: () => import('@/views/outpost/Outpost.vue'),
    meta: { title: i18n.global.t('Outpost.Title') + siteName }
  },
  {
    path: "/assistant",
    name: "Assistant",
    component: () => import('@/views/assistant/Assistant.vue'),
    meta: { title: i18n.global.t('Assistant.Title') + siteName }
  },
  {
    path: "/signin",
    name: "Signin",
    // component: Signin,
    component: () => import('@/views/Signin.vue'),
    beforeEnter: () => {
      store.commit('theme/__set', { name: 'showNavbar', val: false })
      store.commit('theme/__set', { name: 'showSidenav', val: false })
      store.commit('theme/__set', { name: 'showFooter', val: false })
      store.commit('theme/__set', { name: 'hideConfigButton', val: true })
    }
  },
  {
    path: "/signup",
    name: "Signup",
    // component: Signup,
    component: () => import('@/views/Signup.vue'),
    beforeEnter: () => {
      store.commit('theme/__set', { name: 'showNavbar', val: false })
      store.commit('theme/__set', { name: 'showSidenav', val: false })
      store.commit('theme/__set', { name: 'showFooter', val: false })
      store.commit('theme/__set', { name: 'hideConfigButton', val: true })
    }
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    // component: Signin,
    component: () => import('@/views/Forgot-password.vue')
  },
  {
    path: "/webapps",
    name: "Webapp",
    // component: Signin,
    component: () => import('@/views/webapp/Webapp.vue')
  },
  {
    path: "/add-app",
    name: "add-app",
    // component: Signin,
    component: () => import('@/views/webapp/NewApp.vue')
  },
  {
    path: "/broadcasting",
    name: "Broadcasting",
    // component: AddBot,
    component: () => import('@/views/mailing/Mailing.vue'),
    meta: { title: 'Broadcasting' + siteName }
  },
  {
    path: "/mailing",
    redirect: "/broadcasting"
  },
  {
    path: "/broadcasting/edit-campaign/:id?",
    name: "EditCampaign",
    // component: AddBot,
    component: () => import('@/views/mailing/EditCampaign/EditCampaign.vue'),
    meta: { title: 'Edit Campaign' + siteName }
  },
  {
    path: "/broadcasting/campaign/:id?",
    name: "ViewCampaign",
    component: () => import('@/views/mailing/ViewCampaign.vue'),
    meta: { title: 'View Campaign' + siteName }
  },
  {
    path: "/integrations",
    name: "Integrations",
    component: () => import('@/views/integrations/IntegrationsList.vue'),
    meta: { title: 'Integrations - ' + siteName }
  },
  // Dynamic route for creating a new integration by provider (catalog entry)
  // e.g. /integrations/new/amocrm or /integrations/new/kommo
  {
    path: "/integrations/new/:provider",
    name: "IntegrationProvider",
    component: () => import('@/views/integrations/IntegrationProvider.vue'),
    meta: { title: 'Integration - ' + siteName }
  },
  // Dynamic route to open a specific integration by its unique key (wrapper selects concrete component)
  {
    path: "/integrations/:integration_key",
    name: "IntegrationView",
    component: () => import('@/views/integrations/IntegrationView.vue'),
    meta: { title: 'Integration - ' + siteName }
  },
  {
    path: "/custom-fields",
    name: "CustomFields",
    component: () => import('@/views/customFields/CustomFields.vue'),
    meta: { title: i18n.global.t('Meta.Title.CustomFields') + siteName }
  },
  {
    path: "/user-reports",
    name: "UserReportsList",
    component: () => import('@/views/reports/UserReportsList.vue'),
    meta: { title: 'My Reports' + siteName }
  },
  {
    path: "/user-reports/view/:uuid",
    name: "UserReportView",
    component: () => import('@/views/reports/UserReportView.vue'),
    meta: { title: 'View Report' + siteName }
  },

  {
    path: "/report-builder",
    name: "report-builder",
    // component: AddBot,
    component: () => import('@/views/report_builder/builder/Builder.vue')
  },
  {
    path: "/cohorts",
    name: "cohorts",
    component: () => import('@/views/cohorts/Cohorts.vue'),
    meta: { title: 'Cohorts' }
  },
  {
    path: "/ads/report",
    name: "AdsReport",
    component: () => import('@/views/ads/CacReport.vue'),
    meta: { title: i18n.global.t('Ads.Report.Title') + siteName }
  },
  {
    path: "/ads/accounts",
    name: "AdsAccounts",
    component: () => import('@/views/ads/AdAccounts.vue'),
    meta: { title: i18n.global.t('Ads.Accounts.Title') + siteName }
  },
  {
    path: "/ads/campaigns",
    name: "AdsCampaigns",
    component: () => import('@/views/ads/AdCampaigns.vue'),
    meta: { title: i18n.global.t('Ads.Campaigns.Title') + siteName }
  },
  {
    path: "/referral",
    name: "ReferralOverview",
    component: () => import('@/views/referral/Overview.vue'),
    meta: { title: i18n.global.t('Referral.Overview.Title') + siteName }
  },
  {
    path: "/referral/settings",
    name: "ReferralSettings",
    component: () => import('@/views/referral/Settings.vue'),
    meta: { title: i18n.global.t('Referral.Settings.Title') + siteName }
  },
  {
    path: "/referral/referrers",
    name: "ReferralReferrers",
    component: () => import('@/views/referral/Referrers.vue'),
    meta: { title: i18n.global.t('Referral.Referrers.Title') + siteName }
  },
  {
    path: "/referral/referrals",
    name: "ReferralReferrals",
    component: () => import('@/views/referral/Referrals.vue'),
    meta: { title: i18n.global.t('Referral.Referrals.Title') + siteName }
  },
  {
    path: "/referral/accruals",
    name: "ReferralAccruals",
    component: () => import('@/views/referral/Accruals.vue'),
    meta: { title: i18n.global.t('Referral.Accruals.Title') + siteName }
  },
  {
    path: "/referral/payouts",
    name: "ReferralPayouts",
    component: () => import('@/views/referral/Payouts.vue'),
    meta: { title: i18n.global.t('Referral.PayoutsList.Title') + siteName }
  },
  {
    path: "/referral/referrer-card",
    name: "ReferrerCard",
    component: () => import('@/views/referral/ReferrerCard.vue'),
    meta: { title: i18n.global.t('Referral.ReferrerCard.PageTitle') + siteName }
  },
  {
    path: "/landings",
    name: "Landings",
    component: () => import('@/views/landings/Landings.vue'),
    meta: { title: i18n.global.t('Landings.Title') + siteName }
  },
  {
    path: "/database/events",
    name: "DatabaseEvents",
    component: () => import('@/views/database/Events.vue'),
    meta: { title: i18n.global.t('Database.Events.Title') + siteName }
  },
  {
    path: "/database/messages",
    name: "DatabaseMessages",
    component: () => import('@/views/database/Messages.vue'),
    meta: { title: i18n.global.t('Database.Messages.Title') + siteName }
  },
  {
    path: "/public-stats",
    name: "PublicStats",
    component: () => import('@/views/publicStats/PublicStats.vue'),
    meta: { title: i18n.global.t('PublicStats.Title') + siteName }
  },
  {
    path: "/affiliate",
    name: "Affiliate",
    component: () => import('@/views/affiliate/Affiliate.vue'),
    meta: { title: i18n.global.t('Affiliate.Title') + siteName }
  },
  {
    path: "/dashboards",
    name: "DashboardsList",
    component: () => import('@/views/Dashboard/DashboardsList.vue'),
    meta: { title: 'Dashboards' + siteName }
  },
  {
    path: "/dashboards/:id",
    name: "DashboardView",
    component: () => import('@/views/Dashboard/DashboardView.vue'),
    meta: { title: 'Dashboard' + siteName }
  },
  {
    path: "/workflows",
    name: "WorkflowsList",
    component: () => import('@/views/workflows/WorkflowsList.vue'),
    meta: { title: 'Автоматизации - ' + siteName }
  },
  {
    path: "/workflows/new",
    name: "WorkflowNew",
    component: () => import('@/views/workflows/WorkflowDetails.vue'),
    meta: { title: 'Создание автоматизации - ' + siteName }
  },
  {
    path: "/workflows/catalog",
    name: "WorkflowTemplatesCatalog",
    component: () => import('@/views/workflows/WorkflowTemplatesCatalog.vue'),
    meta: { title: 'Каталог автоматизаций - ' + siteName }
  },
  {
    // Объявлен ДО "/workflows/:id", иначе обзор ушёл бы в него как id (как и /workflows/catalog).
    path: "/workflows/overview",
    name: "WorkflowsOverview",
    component: () => import('@/views/workflows/WorkflowsOverview.vue'),
    meta: { title: 'Обзор автоматизаций - ' + siteName }
  },
  {
    path: "/workflows/:id",
    name: "WorkflowDetails",
    component: () => import('@/views/workflows/WorkflowDetails.vue'),
    meta: { title: 'Детали автоматизации - ' + siteName }
  },
  {
    path: "/workflow_canvas/:wid/:wvid?",
    name: "WorkflowCanvas",
    component: () => import('@/views/workflows/WorkflowEditor.vue'),
    meta: { title: 'Конструктор автоматизации - ' + siteName }
  },
  {
    path: "/usage",
    name: "Usage",
    component: () => import('@/views/usage/Usage.vue'),
    meta: { title: 'Потребляемые ресурсы' + siteName }
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import('@/views/projects/ProjectsList.vue'),
    meta: { title: 'Projects' + siteName }
  },
  {
    path: "/projects/:code/permissions",
    name: "ProjectPermissions",
    component: () => import('@/views/projects/ProjectPermissions.vue'),
    meta: { title: 'Permissions' + siteName }
  },
  {
    path: "/admin/users",
    name: "AdminUsers",
    component: () => import('@/views/admin/UsersList.vue'),
    meta: { title: 'Admin - Users' + siteName }
  },
  {
    path: "/admin/bots",
    name: "AdminBots",
    component: () => import('@/views/admin/BotsList.vue'),
    meta: { title: 'Admin - Bots' + siteName }
  },
  {
    path: "/admin/billing",
    name: "AdminBilling",
    component: () => import('@/views/admin/BillingList.vue'),
    meta: { title: 'Admin - Billing' + siteName }
  },
  {
    path: "/admin/billing-stats",
    name: "AdminBillingStats",
    component: () => import('@/views/admin/BillingChargeStats.vue'),
    meta: { title: 'Admin - Billing Stats' + siteName }
  },
  {
    path: "/admin/usage",
    name: "AdminUsage",
    component: () => import('@/views/admin/UsageList.vue'),
    meta: { title: 'Admin - Monthly Usage' + siteName }
  },
  {
    path: "/admin/payments",
    name: "AdminPayments",
    component: () => import('@/views/admin/PaymentsList.vue'),
    meta: { title: 'Admin - Payments' + siteName }
  },
  {
    path: "/admin/assistant",
    name: "AdminAssistant",
    component: () => import('@/views/admin/AssistantAdmin.vue'),
    meta: { title: 'Admin - AI Assistant' + siteName }
  },
  {
    path: "/admin/workflow-templates",
    name: "AdminWorkflowTemplates",
    component: () => import('@/views/admin/WorkflowTemplatesList.vue'),
    meta: { title: 'Admin - Workflow Templates' + siteName }
  },
  {
    path: "/admin/tags",
    name: "AdminTags",
    component: () => import('@/views/admin/TagsList.vue'),
    meta: { title: 'Admin - Tags' + siteName }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: { title: 'Сраница не найдена - ' + siteName }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Показываем тонкий индикатор навигации только если переход реально не
// мгновенный (например качается lazy-чанк тяжёлого роута) — избегаем мигания
// на обычных быстрых переходах между уже закэшированными страницами.
let routeLoadingTimer = null
const ROUTE_LOADING_DELAY = 150

router.beforeEach(async (routeTo) => {
  const noAuthPages = ['Signin', 'Signup', 'ForgotPassword'];

  clearTimeout(routeLoadingTimer)
  routeLoadingTimer = setTimeout(() => {
    store.commit('theme/__set', { name: 'routeLoading', val: true })
  }, ROUTE_LOADING_DELAY)

  return await store.dispatch('init/init').then(data => {
    if (data.user && noAuthPages.includes(routeTo.name)) {
      store.commit('theme/__set', { name: 'loadingApp', val: false })
      return { name: 'Home', query: routeTo.query }
    } else if (!data.user && !noAuthPages.includes(routeTo.name)) {
      store.commit('theme/__set', { name: 'loadingApp', val: false })
      return { name: 'Signin', query: routeTo.query }
    } else {
      // Admin gate
      if (routeTo.path.startsWith('/admin') && (!data.user || !data.user.admin)) {
        ElNotification({
          title: i18n.global.t('General.Warning'),
          message: 'Access Denied',
          type: 'error'
        })
        store.commit('theme/__set', { name: 'loadingApp', val: false })
        return { name: 'Home', query: routeTo.query }
      }

      // Tariff-based access gate
      const match = routeTo.matched && routeTo.matched.find(r => r.meta && r.meta.requireTariff)
      const requireTariff = match ? match.meta.requireTariff : null
      if (requireTariff && (!data.user || data.user.tariff !== requireTariff)) {
        // Notify and redirect to tariff selection page
        ElNotification({
          title: i18n.global.t('General.Warning'),
          message: i18n.global.t('Notify.NotAllowOnTariff'),
          type: 'warning'
        })
        store.commit('theme/__set', { name: 'loadingApp', val: false })
        return { name: 'Usage', query: routeTo.query }
      }
      // Диплинк с принудительным выбором ресурса: /users?resource_key=<key>&user_id=<id>.
      // Доступ определяет бэкенд: в user_bots приходят только доступные пользователю ресурсы.
      const deepLinkResourceKey = routeTo.query.resource_key
      if (data.user && deepLinkResourceKey && store.state.init.current_bot?.key !== deepLinkResourceKey) {
        const bot = store.state.init.user_bots?.[deepLinkResourceKey]
        if (bot) {
          store.commit('init/setCurrentBot', bot)
        } else {
          ElNotification({
            title: i18n.global.t('General.Warning'),
            message: i18n.global.t('General.ErrorsText.AccessDenied'),
            type: 'error'
          })
        }
      }
      const hasResources = data.user && Object.keys(store.state.init.user_bots).length > 0
      store.commit('theme/__set', { name: 'showSidenav', val: hasResources })
      store.commit('theme/__set', { name: 'loadingApp', val: false })

      // Redirect "/" to the user's chosen default dashboard, if any.
      // If no default is chosen, land on the system dashboard matching the
      // current resource type (channel/bot) instead of the old fixed dashboard.
      // 'standard' (old fixed dashboard) is no longer a settable default — legacy
      // stored values are treated the same as "no default".
      if (routeTo.name === 'Home' && hasResources) {
        // Dashboards require report.view (see AccessService::getUserPermissionsSummary /
        // DashboardService) — a user granted access to only e.g. mailings would otherwise land
        // on a dashboard they can't open (empty screen + the 403 notification, on every login).
        if (!store.getters['init/can']('report.view')) {
          return { path: getFirstAccessibleSection(store), query: routeTo.query }
        }
        const defaultDashboardId = getDefaultDashboardId()
        if (defaultDashboardId && defaultDashboardId !== 'standard') {
          return { path: `/dashboards/${defaultDashboardId}`, query: routeTo.query }
        } else {
          const systemDashboardId = getSystemDashboardIdForResource(store.state.init.current_bot)
          return { path: `/dashboards/${systemDashboardId}`, query: routeTo.query }
        }
      }

      return true
    }
  })

  // if (user === null) {
  //
  // }
  // let authProcessing = store.getters['init/getProcessing']
  // console.log(authProcessing)
  // if (authProcessing !== null) {
  //   console.log(authProcessing)
  //   store.getters['init/getProcessing'].then(data => {
  //     console.log(data)
  //     if (data.user === null && authpage) {
  //
  //       return { name: 'Signin' }
  //       // next('/login')
  //     } else if (data.user !== null && !authpage) {
  //       return { name: '/' }
  //       // next('/')
  //     }
  //   }).catch(() => {
  //     if (routeTo.path !== '/error') {
  //       return { name: 'error' }
  //       // next('/error');
  //     }
  //   }).finally(() => {
  //     console.log(12)
  //   })
  // }
  // next();
  // return true
  // }
})

router.afterEach(() => {
  clearTimeout(routeLoadingTimer)
  store.commit('theme/__set', { name: 'routeLoading', val: false })
})

router.onError((error, to) => {
  clearTimeout(routeLoadingTimer)
  store.commit('theme/__set', { name: 'routeLoading', val: false })

  const isChunkError = error.name === 'ChunkLoadError'
    || /loading chunk \d+ failed/i.test(error.message)
    || /loading css chunk \d+ failed/i.test(error.message)
  if (isChunkError) {
    const RELOAD_KEY = 'chunk_reload_at'
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
    const now = Date.now()
    if (now - last > 10000) {
      sessionStorage.setItem(RELOAD_KEY, String(now))
      window.location.assign(to?.fullPath ?? window.location.pathname)
    }
  }
})

export default router;
